import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import {
  map,
  distinctUntilChanged,
  filter
  // throttleTime,
  // delayWhen
} from 'rxjs/operators';
import { isEqual } from 'lodash';
import {
  LoadOrders,
  ReLoad
  // MuniEnvironmentParams,
  // CasaUpdateMessage,
  // THROTTLE_DELAY,
  // getMessageDelay,
  // MuniEnvironment
} from '@ipreo/muni-shared';
import { ResetData } from '../../../state/data/actions';
// import {
//   EnvironmentConfig,
//   ENVIRONMENT_CONFIG,
//   WebsocketGatewayService
// } from '@ipreo/northstar';
import { getGamedayDealState } from '../../../state/data/reducer';

const POLLING_INTERVAL = 30000;

@Component({
  selector: 'muni-gameday-deal',
  templateUrl: './deal.template.html',
  styleUrls: ['./deal.styles.scss'],
  standalone: false,
})
export class DealComponent implements OnDestroy {
  private readonly dealId$: Observable<string> = this.activatedRoute.params.pipe(
    map(({ id }: { id: string }) => id),
    distinctUntilChanged()
  );

  private readonly paramsSubscription: Subscription = this.dealId$.subscribe(
    (dealId) => this.loadOrders(dealId)
  );

  // private wsgServiceChannelName: string;
  // private liveSubscription: Subscription;

  private readonly ordersLiveSubscriptionParams$: Observable<{
    dealId: string;
    seniorManagerId: number;
  }> = this.store.pipe(
    select(getGamedayDealState),
    filter((deal) => !!deal),
    map((deal) => ({
      dealId: deal.id,
      seniorManagerId: deal.seniorManager.id
    })),
    distinctUntilChanged(isEqual)
  );

  private readonly liveUpdatesParamsSubscription: Subscription = this.ordersLiveSubscriptionParams$.subscribe(
    (liverUpdatesParams) => {
      this.stopOrdersLiveUpdates();
      this.startOrdersLiveUpdates(
        liverUpdatesParams.dealId,
        liverUpdatesParams.seniorManagerId
      );
    }
  );

  // private readonly env: MuniEnvironment;

  private pollIntervalID: undefined | ReturnType<typeof setTimeout>;

  constructor(
    private store: Store<Record<string, unknown>>,
    private router: Router, // private wsgService: WebsocketGatewayService,
    private activatedRoute: ActivatedRoute // @Inject(ENVIRONMENT_CONFIG) config: EnvironmentConfig
  ) {
    // this.env = (config.params as MuniEnvironmentParams).env;
  }

  public ngOnDestroy(): void {
    this.paramsSubscription.unsubscribe();
    this.liveUpdatesParamsSubscription.unsubscribe();
    clearInterval(this.pollIntervalID);
    // this.stopOrdersLiveUpdates();
    this.store.dispatch(new ResetData());
  }

  public loadOrders(dealId: string): void {
    this.store.dispatch(new ReLoad(dealId));
    this.store.dispatch(new LoadOrders({ dealId, reload: false }));
  }

  public goBack() {
    this.router.navigate(['../'], {
      relativeTo: this.activatedRoute.children.length
        ? this.activatedRoute.children[0]
        : this.activatedRoute
    });
  }

  private stopOrdersLiveUpdates() {
    // if (this.liveSubscription) {
    //   this.liveSubscription.unsubscribe();
    //   this.wsgService.unsubscribe(this.wsgServiceChannelName);
    //   this.wsgServiceChannelName = undefined;
    //   this.liveSubscription = undefined;
    // }
  }

  private startOrdersLiveUpdates(dealId: string, seniorManagerId: number) {
    this.pollIntervalID = setInterval(() => {
      this.store.dispatch(new ReLoad(dealId));
      this.store.dispatch(new LoadOrders({ dealId, reload: false }));
    }, POLLING_INTERVAL);

    // The Socket is Timing out after 2 hrs and reconnect logic is not currently implemented.
    // Will Re-enable it once the code is fixed as this is critical now, will be done as a part of EDVR-14837

    // this.wsgServiceChannelName = this.configureChannelName(
    //   this.env,
    //   dealId,
    //   seniorManagerId
    // );
    // this.liveSubscription = this.wsgService
    //   .subscribe(this.wsgServiceChannelName)
    //   .pipe(
    //     throttleTime(THROTTLE_DELAY),
    //     delayWhen((msg: CasaUpdateMessage) => timer(getMessageDelay(msg)))
    //   )
    //   .subscribe((msg: CasaUpdateMessage) => {
    //     if (msg.Updates.includes('Orders')) {
    //       this.store.dispatch(new LoadOrders({ dealId, reload: true }));
    //     }
    //   });
  }

  // private configureChannelName(
  //   env: MuniEnvironment,
  //   dealId: string,
  //   seniorManagerId: number
  // ): string {
  //   const base = 'casa-muni-updates';
  //   const params = [dealId, seniorManagerId];

  //   if (env !== MuniEnvironment.prod) {
  //     params.unshift(this.env);
  //   }

  //   return base + params.map((p) => `-${p}`).join('');
  // }
}
